





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { EventBus } from '@/utils/EventBus';

type Status = 'cancel' | 'loading' | 'completed';

@Component({
  components: {
    AlpacaBtn,
  },
})
export default class TransactionResultPopup extends Vue {
  public showDialog: boolean = false;
  public status: Status = 'loading';
  public trxId: string = '';
  public wording: string = '';

  get isBSC() {
    return process.env.VUE_APP_BSC;
  }

  public mounted() {
    EventBus.$on('trx-result', this.getResult);
  }

  public getResult(result: {status: Status, trxId: string, wording: string}) {
    this.status = result.status;
    this.trxId = result.trxId;
    this.wording = result.wording || '';
    this.showDialog = true;
  }

  public viewTrx() {
    window.open(`${process.env.VUE_APP_NET}tx/` + this.trxId, '_blank');
  }

  public close() {
    this.showDialog = false;
  }
}
